import { addValidationRule } from 'formsy-react';
const isExisty = (value) => value !== null && value !== undefined;
const isEmpty = (value) => value === '';
const validations = {
    pattern(_, value, regexp) {
        return !isExisty(value) || isEmpty(value) || regexp.test(value);
    },
    email(values, value) {
        // Regex from http://emailregex.com/
        return validations.pattern(values, value, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
    },
    url(values, value) {
        return validations.pattern(values, value, /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/i);
    },
    number(values, value) {
        if (typeof value === 'number') {
            return true;
        }
        return validations.pattern(values, value, /^[-]?(?:\d*[.])?\d+$/);
    },
    alpha(values, value) {
        return validations.pattern(values, value, /^[A-Z]+$/i);
    },
    alphaNumber(values, value) {
        return validations.pattern(values, value, /^[0-9A-Z]+$/i);
    },
    int(values, value) {
        return validations.pattern(values, value, /^(?:[-]?(?:0|[1-9]\d*))$/);
    },
    float(values, value) {
        return validations.pattern(values, value, /^(?:[-]?(?:\d+))?(?:\.\d*)?(?:[eE][-]?(?:\d+))?$/);
    },
    equals(_, value, eql) {
        return !isExisty(value) || isEmpty(value) || value === eql;
    },
    equalsField(values, value, field) {
        return value === values[field];
    },
    length(_, value, length) {
        return !isExisty(value) || isEmpty(value) || value.length === length;
    },
    maxLength(_, value, length) {
        return !isExisty(value) || value.length <= length;
    },
    minLength(_, value, length) {
        return !isExisty(value) || isEmpty(value) || value.length >= length;
    },
    percent(values, value) {
        // 0-100的百分比数，允许最多保留两位小数
        return validations.pattern(values, value, /^(\d|[1-9]\d|100(\.0{1,2})?)(\.\d{1,2})?$/);
    },
    whitespace(values, value, allow) {
        // 是否允许空白字符
        return allow ? true : !validations.pattern(values, value, /\s/g);
    },
    phone(values, value) {
        // 电话号码或者手机号码
        return validations.cellphone(values, value) || validations.telephone(values, value);
    },
    cellphone(values, value) {
        // 手机号码
        return validations.pattern(values, value, /^1[3|4|5|6|7|8|9][0-9]\d{8}$/);
    },
    telephone(values, value) {
        // 电话号码
        return validations.pattern(values, value, /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/);
    },
    idCard(values, value) {
        // 身份证号码
        return validations.pattern(values, value, /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$/);
    },
    zipCode(values, value) {
        // 中国邮编
        return validations.pattern(values, value, /^[1-9]\d{5}(?!\d)$/);
    },
    ip(values, value) {
        // ip地址
        return validations.pattern(values, value, /^((?:(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))))$/);
    }
};
for (const key in validations) {
    if (Object.prototype.hasOwnProperty.call(validations, key)) {
        const validation = validations[key];
        addValidationRule(key, validation);
    }
}
export default validations;
